import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "@/constants/testIds";
import { waLink, WHATSAPP_BUSINESS } from "@/lib/api";

export const WhatsappFab = () => {
  return (
    <motion.a
      data-testid={WHATSAPP.fab}
      href={waLink(WHATSAPP_BUSINESS)}
      target="_blank"
      rel="noreferrer"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5, duration: 0.5 }}
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] text-white rounded-full shadow-2xl px-4 py-4 md:px-5 md:py-4 hover:scale-105 active:scale-95 transition-transform"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
      <MessageCircle className="w-6 h-6 relative z-10" />
      <span className="hidden md:inline text-sm font-semibold relative z-10">Chat with us</span>
    </motion.a>
  );
};
